import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import { TextArea } from 'common-src/components/base';
import {
  getCognitivePatientScores,
  getPatientScoreResult,
  getPatientScoreType,
  ScoreType,
} from 'common-src/models/PatientScore';

import useCustomSelector from 'src/hooks/useCustomSelector';
import commonStyles from 'src/pages/DocumentationIndex/commonStyles.module.scss';

import styles from './CognitiveScreeningModule.module.scss';

const CognitiveScreeningModule = ({
  patientId,
  cognitiveScreening,
  setCognitiveScreening,
  showOnlyZBI22,
}) => {
  const patientScores = useCustomSelector((state) => getCognitivePatientScores(state, patientId));

  const getScores = () => {
    if (patientScores.length === 0) return 'No scores available';

    return patientScores
      .filter(
        (score) =>
          !showOnlyZBI22 ||
          score.scoreType === ScoreType.ZBI22Assessment.value ||
          score.scoreType === ScoreType.ZBI22ScreeningUnassisted.value ||
          score.scoreType === ScoreType.ZBI22ScreeningAssisted.value,
      )
      .map(
        (score) =>
          `${getPatientScoreType(score.scoreType)}: ${getPatientScoreResult(score)}, Result date: ${moment(score.resultDate).format('MM/DD/YYYY')}`,
      )
      .join('\n\n');
  };

  useEffect(() => {
    setCognitiveScreening((prev) => ({
      ...prev,
      scores: getScores(),
    }));
  }, [patientScores]);

  return (
    <div className={styles.container}>
      <p className={['font-w-600', 'font-s-16', 'm-b-14'].join(' ')}>
        {showOnlyZBI22 ? 'ZBI-22 Assessment' : 'Cognitive Screening'}
      </p>
      <TextArea
        id="cognitive-screening-scores"
        classNames={[styles.textArea]}
        inputClassNames={[commonStyles.inputText]}
        label="Scores"
        value={cognitiveScreening.scores}
        maxRows={10}
        size="small"
        withError={false}
        readOnly
      />
    </div>
  );
};

CognitiveScreeningModule.propTypes = {
  patientId: PropTypes.number,
  cognitiveScreening: PropTypes.object,
  setCognitiveScreening: PropTypes.func,
  showOnlyZBI22: PropTypes.bool,
};

export default CognitiveScreeningModule;
